const modalContainer = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "92%", sm: "640px", md: "760px" },
  maxWidth: "760px",
  maxHeight: "90vh",
  overflowY: "auto",
  backgroundColor: "white",
  borderRadius: "16px",
  boxShadow: "0 24px 60px rgba(17, 24, 39, 0.18)",
  border: "1px solid #e5e7eb",
  outline: "none",
};

const modalContent = {
  padding: { xs: "1.25rem", sm: "1.75rem" },
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "0.75rem",
};

const modalTitle = {
  margin: 0,
  fontSize: { xs: "1.15rem", sm: "1.4rem" },
  fontWeight: 700,
  color: "#111827",
  letterSpacing: "-0.01em",
};

const divider = {
  margin: "1rem 0 1.25rem",
  borderColor: "#e5e7eb",
};

const formSection = {
  marginBottom: "1.25rem",
  border: "1px solid #eef2f7",
  borderRadius: "12px",
  backgroundColor: "#fcfdff",
  padding: "1rem",
};

const sectionTitle = {
  fontSize: "0.8rem",
  fontWeight: 600,
  color: "#6b7280",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: "0.9rem",
};

const autoGeneratedTitleBox = {
  padding: "0.75rem 1rem",
  backgroundColor: "#f9fafb",
  borderRadius: "8px",
  border: "1px solid #e5e7eb",
  marginBottom: "1rem",
};

const autoGeneratedTitleText = {
  fontSize: "0.875rem",
  color: "#374151",
  fontFamily: "monospace",
  wordBreak: "break-all",
};

const formGrid = {
  marginTop: "0.25rem",
};

const fieldLabel = {
  fontSize: "0.78rem",
  fontWeight: 600,
  color: "#6b7280",
  marginBottom: "0.35rem",
};

const formField = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "& fieldset": {
      borderColor: "#d1d5db",
    },
    "&:hover fieldset": {
      borderColor: "#94a3b8",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#367598",
      borderWidth: "1px",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#367598",
  },
};

const helperText = {
  marginLeft: "0.1rem",
  marginTop: "0.35rem",
  fontSize: "0.74rem",
};

const domainSelect = {
  "& .MuiSelect-select": {
    minHeight: "20px",
    display: "flex",
    alignItems: "center",
    gap: "0.35rem",
    flexWrap: "wrap",
    paddingTop: "9px",
    paddingBottom: "9px",
  },
};

const selectedDomainChip = {
  height: "22px",
  borderRadius: "999px",
  backgroundColor: "#eaf3f9",
  color: "#2d5f7a",
  fontSize: "0.72rem",
  fontWeight: 600,
  border: "1px solid #d5e7f2",
};

const nextBatchInfoBox = {
  border: "1px solid #dbeafe",
  borderRadius: "10px",
  background: "linear-gradient(180deg, #f8fbff 0%, #f3f8fc 100%)",
  padding: "0.8rem 1rem",
};

const nextBatchInfoText = {
  fontSize: "0.8rem",
  color: "#475569",
};

const buttonContainer = {
  marginTop: "1.25rem",
  paddingTop: "1rem",
  borderTop: "1px solid #e5e7eb",
};

const submitButton = {
  textTransform: "none",
  fontWeight: 700,
  padding: "0.72rem 1.6rem",
  borderRadius: "10px",
  backgroundColor: "#367598",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#2d5f7a",
    boxShadow: "0 8px 20px rgba(45, 95, 122, 0.35)",
  },
};

const cancelButton = {
  textTransform: "none",
  fontWeight: 600,
  padding: "0.625rem 1.5rem",
  borderRadius: "10px",
  borderColor: "#cbd5e1",
  color: "#374151",
};

const successContainer = {
  padding: "0.75rem 0",
};

const successHeader = {
  display: "flex",
  alignItems: "flex-start",
  gap: "0.9rem",
  marginBottom: "1.25rem",
  padding: "0.75rem",
  borderRadius: "10px",
  backgroundColor: "#ecfdf5",
  border: "1px solid #bbf7d0",
};

const successIcon = {
  color: "#10b981",
  fontSize: "2rem",
};

const successTitle = {
  fontSize: "1.1rem",
  fontWeight: 600,
  color: "#111827",
};

const successMessage = {
  fontSize: "0.875rem",
  color: "#6b7280",
  marginTop: "0.25rem",
};

const successMetaGrid = {
  marginBottom: "0.25rem",
};

const successMetaCard = {
  border: "1px solid #e5e7eb",
  borderRadius: "10px",
  backgroundColor: "#ffffff",
  padding: "0.65rem 0.85rem",
};

const successMetaLabel = {
  fontSize: "0.71rem",
  fontWeight: 700,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  marginBottom: "0.2rem",
};

const successMetaValue = {
  fontSize: "0.95rem",
  fontWeight: 700,
  color: "#0f172a",
};

const copySection = {
  marginBottom: "1rem",
};

const copySectionCard = {
  marginBottom: "1rem",
  border: "1px solid #e5e7eb",
  borderRadius: "12px",
  backgroundColor: "#f8fafc",
  padding: "0.85rem",
};

const copySectionLabel = {
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "#6b7280",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: "0.5rem",
};

const copyFieldContainer = {
  display: "flex",
  gap: "0.6rem",
  alignItems: "flex-start",
  flexDirection: { xs: "column", sm: "row" },
};

const copyTextField = {
  flex: 1,
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontSize: "0.82rem",
    "& fieldset": {
      borderColor: "#e5e7eb",
    },
  },
};

const copyButton = {
  textTransform: "none",
  minWidth: "100px",
  borderRadius: "10px",
  fontWeight: 600,
  alignSelf: { xs: "stretch", sm: "flex-start" },
  "&:hover": {
    backgroundColor: "#f3f4f6",
  },
};

const keywordsSection = {
  marginTop: "1rem",
};

const keywordsTitle = {
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "#6b7280",
  marginBottom: "0.75rem",
};

const loaderContainer = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "300px",
};

export {
  modalContainer,
  modalContent,
  modalHeader,
  modalTitle,
  divider,
  formSection,
  sectionTitle,
  autoGeneratedTitleBox,
  autoGeneratedTitleText,
  formGrid,
  fieldLabel,
  formField,
  helperText,
  domainSelect,
  selectedDomainChip,
  nextBatchInfoBox,
  nextBatchInfoText,
  buttonContainer,
  submitButton,
  cancelButton,
  successContainer,
  successHeader,
  successIcon,
  successTitle,
  successMessage,
  successMetaGrid,
  successMetaCard,
  successMetaLabel,
  successMetaValue,
  copySection,
  copySectionCard,
  copySectionLabel,
  copyFieldContainer,
  copyTextField,
  copyButton,
  keywordsSection,
  keywordsTitle,
  loaderContainer,
};
